/**
 * Visible text of TipTap HTML. Used to drop empty editor rows.
 * Do not use this on save — persist message HTML.
 */

export function htmlToPlainText(html: string): string {
  if (!html.trim()) {
    return '';
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}
